import BackdropMUI from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelectorApp } from "../../lib/redux";

const Backdrop = () => {
  const { showBackdrop } = useSelectorApp((state) => state.ui);
  return (
    <BackdropMUI
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 2000 }}
      open={showBackdrop}
    >
      <CircularProgress color="inherit" />
    </BackdropMUI>
  );
};

export default Backdrop;
